export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-team-line',
      title: 'Professional Team',
      description: 'Trained, experienced and trustworthy staff for superior quality service'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly Products',
      description: 'Use of environmentally friendly cleaning products that are safe for your health'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Satisfaction Guarantee',
      description: 'If you\'re not satisfied, we come back for free to make it right'
    },
    {
      icon: 'ri-time-line',
      title: 'Flexible Hours',
      description: 'Services adapted to your schedule, available 7 days a week'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Transparent Pricing',
      description: 'Free and detailed quote with no hidden fees or surprises'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Local Service',
      description: 'Local business that knows Westbrook and Portland perfectly'
    }
  ];

  return (
    <section id="why-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose <strong>Ecomez</strong>?
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Your trusted partner for <strong>cleaning and maintenance</strong> in <strong>Westbrook and Portland</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${reason.icon} text-3xl text-teal-600`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                {reason.title}
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
